(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["404-page"] && !window.DesignMode) return;
  try {
    

    jQuery(".slidem").prepend(jQuery(".slidem > div:last").clone()); /* copy last div for the first slideup */
jQuery.fn.slideFadeToggle  = function(speed, easing, callback) {
	return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
}; /* slideup fade toggle code */
var divS = jQuery(".slidem > div"), /* get the divs to slideup */
	sDiv = jQuery(".slidem > div").length, /* get the number of divs to slideup */
	n = 0; /* starting counter */
function slidethem() { /* slide fade function */
	jQuery( divS ).eq( n ).slideFadeToggle(1000,"swing",n=n+1); /* slide fade the div at 1000ms swing and add to counter */
	jQuery( divS ).eq( n ).show(); /* make sure the next div is displayed */
}
( function slideit() { /* slide repeater */
	if( n == sDiv ) { /* check if at the last div */
		n = 0; /* reset counter */
		jQuery( divS ).show(); /* reset the divs */
	}
	slidethem(); /* call slide function */
	if(n == sDiv) { /* check if at the last div */
		setTimeout(slideit,1); /* slide up first div fast */
	} else {
		setTimeout(slideit,4000); /* slide up every 1000ms */
	}
} )();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-banner-11-9-2023"] && !window.DesignMode) return;
  try {
    

    jQuery(".slidem").prepend(jQuery(".slidem > div:last").clone()); /* copy last div for the first slideup */
jQuery.fn.slideFadeToggle  = function(speed, easing, callback) {
	return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
}; /* slideup fade toggle code */
var divS = jQuery(".slidem > div"), /* get the divs to slideup */
	sDiv = jQuery(".slidem > div").length, /* get the number of divs to slideup */
	n = 0; /* starting counter */
function slidethem() { /* slide fade function */
	jQuery( divS ).eq( n ).slideFadeToggle(1000,"swing",n=n+1); /* slide fade the div at 1000ms swing and add to counter */
	jQuery( divS ).eq( n ).show(); /* make sure the next div is displayed */
}
( function slideit() { /* slide repeater */
	if( n == sDiv ) { /* check if at the last div */
		n = 0; /* reset counter */
		jQuery( divS ).show(); /* reset the divs */
	}
	slidethem(); /* call slide function */
	if(n == sDiv) { /* check if at the last div */
		setTimeout(slideit,1); /* slide up first div fast */
	} else {
		setTimeout(slideit,2000); /* slide up every 1000ms */
	}
} )();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-original"] && !window.DesignMode) return;
  try {
    

    jQuery(window).scroll(function() {    
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 500) {
            jQuery(".header").addClass("sticky-header");
        }else {
            $(".header").removeClass("sticky-header");
        }
    });

    jQuery('ul.navbar-nav li:first-child a').addClass('active');
    
    jQuery(window).scroll(function(){
        var $sections = jQuery('section');
        $sections.each(function(i,el){
            var top  = jQuery(el).offset().top-100;
            var bottom = top +jQuery(el).height();
            var scroll = jQuery(window).scrollTop();
            var id = jQuery(el).attr('id');
            if( scroll > top && scroll < bottom){
                jQuery('ul.navbar-nav li a.active').removeClass('active');
                jQuery('ul.navbar-nav li a[href="#'+id+'"]').addClass('active');

            }
        })
    });

    jQuery("ul.navbar-nav li a").on('click', function(){
        jQuery("ul.navbar-nav li a.active").removeClass("active"); 
        jQuery(this).addClass("active"); 
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !window.DesignMode) return;
  try {
     
document.addEventListener("DOMContentLoaded", function() {
  // Check if the 'formSubmitted' cookie is set
  if (document.cookie.indexOf("formSubmitted=") === -1) {
    // If the cookie is not found, redirect to the homepage or another appropriate page
    window.location.href = "/";
    return; // Prevent further execution of the script
  } else {
    // Optional: Clear the cookie to prevent direct access again
    document.cookie = "formSubmitted=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }

  jQuery(".slidem").prepend(jQuery(".slidem > div:last").clone()); /* copy last div for the first slideup */
  jQuery.fn.slideFadeToggle  = function(speed, easing, callback) {
    return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
  }; /* slideup fade toggle code */
  var divS = jQuery(".slidem > div"), /* get the divs to slideup */
    sDiv = jQuery(".slidem > div").length, /* get the number of divs to slideup */
    n = 0; /* starting counter */
  function slidethem() { /* slide fade function */
    jQuery(divS).eq(n).slideFadeToggle(1000,"swing",function(){ n=n+1; }); /* slide fade the div at 1000ms swing and add to counter */
    if(n < sDiv) {
      jQuery(divS).eq(n).show(); /* make sure the next div is displayed if not at the last one */
    }
  }
  (function slideit() { /* slide repeater */
    if(n >= sDiv) { /* check if at the last div */
      n = 0; /* reset counter */
      jQuery(divS).show(); /* reset the divs */
    }
    slidethem(); /* call slide function */
    setTimeout(slideit, n == 0 ? 1 : 4000); /* adjust timing for repeat */
  })();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-columns"] && !window.DesignMode) return;
  try {
    
   
    // Swiper: Slider
    new Swiper('.swiper-container.multi-columns', {
        loop: true,
        speed:1500,
        autoplay: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 25,
        breakpoints: {
            1920: {
                slidesPerView: 3,
                //spaceBetween: 15
            },
            1028: {
                slidesPerView: 2,
                //spaceBetween: 15
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            660: {
                slidesPerView: 1,
                spaceBetween: 15
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 15
            }
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thank-you"] && !window.DesignMode) return;
  try {
    

    jQuery(".slidem").prepend(jQuery(".slidem > div:last").clone()); /* copy last div for the first slideup */
jQuery.fn.slideFadeToggle  = function(speed, easing, callback) {
	return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
}; /* slideup fade toggle code */
var divS = jQuery(".slidem > div"), /* get the divs to slideup */
	sDiv = jQuery(".slidem > div").length, /* get the number of divs to slideup */
	n = 0; /* starting counter */
function slidethem() { /* slide fade function */
	jQuery( divS ).eq( n ).slideFadeToggle(1000,"swing",n=n+1); /* slide fade the div at 1000ms swing and add to counter */
	jQuery( divS ).eq( n ).show(); /* make sure the next div is displayed */
}
( function slideit() { /* slide repeater */
	if( n == sDiv ) { /* check if at the last div */
		n = 0; /* reset counter */
		jQuery( divS ).show(); /* reset the divs */
	}
	slidethem(); /* call slide function */
	if(n == sDiv) { /* check if at the last div */
		setTimeout(slideit,1); /* slide up first div fast */
	} else {
		setTimeout(slideit,4000); /* slide up every 1000ms */
	}
} )();


  } catch(e) { console.error(e); }
})();
      })();
